import Image1 from "../../assets/aadarsh.jpg";
import Image2 from "../../assets/priyanka.jpg";

export const Data = [
  {
    id: 1,
    image: Image2,
    title: "PropertyStack: propertystack.ai",
    description:
      "A property management system with features such as creating reservation, multi-calendar display, payments and so on. Developed with Java for the backend and ReactJS for the frontend, the website offers a seamless UI/UX experience. ",
    link: "https://propertystack.ai/"
  },
  {
    id: 2,
    image: Image1,
    title: "Matchy: matchy.cl",
    description:
      "An appointment scheduling system with features like scheduling, managing session data, and secure payments. Matchy simplifies the process for professionals and clients. Developed with AWS Lambda, Node.js for backend, and React for frontend.",
    link: "https://matchy.cl/"
  },
  {
    id: 3,
    image: Image2,
    title: "NLFS: nlfsociety.org",
    description:
      "A content management system with features such as updating posts, receiving requests/messages, and enabling secure donations. Developed with CodeIgniter PHP for the backend and Bootstrap for the frontend, the website offers a seamless UI/UX experience. ",
    link: "https://www.nlfsociety.org/"
  },

  // {
  //   id: 3,
  //   image: Image3,
  //   title: "Smritee Mainali",
  //   description:
  //     "A really good job, all aspects of the project were followed step by step and with good results.",
  //   link: "#"
  // },
];